import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import './style.css'
import router from './router/router'
import VueGtag from 'vue-gtag'

const app = createApp(App)

// Configure all plugins before mounting
app.use(router)
app.use(VueGtag, {
  config: { id: "G-BNLBD0P750" }
})

// Mount the app only once
app.mount('#app')
